module.exports = __webpack_public_path__ + "static/img/info.7624a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info.png
// module id = jCfu
// module chunks = 1